import { TProfileConfigContextState } from './ProfileConfigContext';

export const profileConfigSelectors = {
  isOpenProfileCreatedModal: (state: TProfileConfigContextState) => {
    return state.isOpenProfileCreatedModal;
  },
  isOpenHideAccountModal: (state: TProfileConfigContextState) => {
    return state.isOpenHideAccountModal;
  },
  isOpenShowAccountModal: (state: TProfileConfigContextState) => {
    return state.isOpenShowAccountModal;
  },
  isOpenDeleteAccountModal: (state: TProfileConfigContextState) => {
    return state.isOpenDeleteAccountModal;
  },
  notificationSettings: (state: TProfileConfigContextState) => {
    return state.notificationSettings;
  },
  recruiterPreferencesData: (state: TProfileConfigContextState) => {
    return state.recruiterPreferencesData;
  },
  jobSeekerPreferencesData: (state: TProfileConfigContextState) => {
    return state.jobSeekerPreferencesData;
  },
  update: (state: TProfileConfigContextState) => {
    return state.update;
  },
};
